module.exports = __webpack_public_path__ + "img/Weapon_231.ce1a3c0e.png";